module.exports = __webpack_public_path__ + "img/box_refund.a921c766.png";